import { Link } from "react-router-dom";
import { MessageCircle, Info } from "lucide-react";
import { Seo } from "@/components/Seo";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

const STEPS = [
  {
    title: "Buka katalog",
    desc: "Tekan Katalog Produk atau Lihat Semua Produk.",
  },
  {
    title: "Pilih platform",
    desc: "Cari dan pilih layanan digital yang diinginkan.",
  },
  {
    title: "Pilih paket",
    desc: "Tentukan durasi dan periksa harga serta kode produknya.",
  },
  {
    title: "Pesan melalui WhatsApp",
    desc: "Tekan Pesan via WhatsApp untuk mengirim detail pilihan secara otomatis.",
  },
  {
    title: "Konfirmasi dan aktivasi",
    desc: "Ikuti instruksi yang diberikan melalui WhatsApp hingga produk berhasil diaktifkan.",
  },
];

export default function CaraBeliPage() {
  const waUrl = buildStockWhatsAppUrl();
  return (
    <>
      <Seo
        title="Cara Beli"
        description="Cara membeli di Nofina Movie dalam lima langkah: buka katalog, pilih platform, pilih paket, pesan via WhatsApp, lalu konfirmasi dan aktivasi."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="max-w-2xl">
          <h1 className="text-3xl font-extrabold text-nm-text sm:text-4xl">
            Cara Membeli di Nofina Movie
          </h1>
          <p className="mt-2 text-nm-muted">
            Lima langkah sederhana dari membuka katalog hingga produkmu aktif.
          </p>
        </header>

        <ol className="mt-8 space-y-4">
          {STEPS.map((step, i) => (
            <li
              key={i}
              data-testid={`cara-beli-step-${i + 1}`}
              className="flex gap-4 rounded-xl border border-nm-border bg-nm-surface p-5"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-nm-red font-bold text-white">
                {i + 1}
              </span>
              <div>
                <h2 className="font-bold text-nm-text">{step.title}</h2>
                <p className="mt-1 text-sm text-nm-muted">{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex items-start gap-3 rounded-xl border border-nm-red/25 bg-nm-red/5 p-4">
          <Info className="mt-0.5 h-5 w-5 shrink-0 text-nm-red" />
          <p className="text-sm text-nm-muted">
            Sebelum melanjutkan, pastikan nama produk, durasi, harga, dan kode
            produk pada pesan WhatsApp sudah sesuai dengan pilihanmu.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border border-nm-border bg-nm-surface p-6 text-center">
          <h2 className="text-lg font-bold text-nm-text">Siap memesan?</h2>
          <p className="mt-1 text-sm text-nm-muted">
            Buka katalog untuk memilih platform dan paketmu.
          </p>
          <div className="mx-auto mt-5 flex max-w-sm flex-col gap-3 sm:flex-row sm:justify-center">
            <Link
              to="/produk"
              data-testid="cara-beli-catalog-cta"
              className="inline-flex h-11 items-center justify-center rounded-lg bg-nm-red px-6 font-semibold text-white transition-colors hover:bg-nm-red-hover"
            >
              Lihat Semua Produk
            </Link>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cara-beli-whatsapp"
              className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-nm-border bg-nm-surface px-6 font-semibold text-nm-text hover:border-wa/50 hover:text-wa"
            >
              <MessageCircle className="h-4 w-4" />
              Cek Stok via WhatsApp
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
